module.exports = {
      id: "home-tap-mask-usage",
      viewBox: "0 0 1920 902",
      url: __webpack_public_path__ + "images/js_src_vue/page_eagle_landing/sprite.b4f41d19.svg#home-tap-mask-usage",
      toString: function () {
        return this.url;
      }
    }